import React from "react";
import { COMPANY, MANIFESTO, CREDENTIALS } from "@/data/site";

export default function About() {
  return (
    <section
      id="rolam"
      data-testid="about-section"
      className="section"
      style={{ background: "var(--ink-2)", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}
    >
      <div className="site-container">
        <div
          className="ab-grid"
          style={{ display: "grid", gridTemplateColumns: "1fr", gap: 48 }}
        >
          <style>{`
            @media (min-width: 1024px) {
              .ab-grid { grid-template-columns: 0.42fr 0.58fr !important; gap: 80px !important; align-items: start !important; }
            }
          `}</style>

          {/* LEFT */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
              <span style={{ height: 1, background: "var(--gold)", width: 32 }} />
              <span className="eyebrow" data-testid="about-eyebrow">05 — Rólunk</span>
            </div>
            <h2 className="h2" data-testid="about-h2" style={{ margin: 0, marginBottom: 28 }}>
              Totál-Bádogos Kft.,<br />
              <span style={{ color: "var(--gold)" }}>a tetőfedés mesterei.</span>
            </h2>

            <div data-testid="about-photo" style={{ position: "relative", marginTop: 24, maxWidth: 380 }}>
              <div className="photo" style={{ aspectRatio: "4 / 5", width: "100%" }}>
                <span className="eyebrow-muted" style={{ position: "relative", zIndex: 1 }}>
                  Portré
                </span>
              </div>
            </div>

            <div className="body" style={{ marginTop: 28, maxWidth: 420 }}>
              <p style={{ margin: 0 }}>
                {COMPANY.leadTitle}.
              </p>
              <p style={{ margin: "8px 0 0" }}>
                Magyarország · {COMPANY.serviceArea}.
              </p>
            </div>
          </div>

          {/* RIGHT — manifesto + credentials */}
          <div>
            <p className="lead" style={{ margin: 0, fontSize: 16, maxWidth: 580, marginBottom: 40 }}>
              Családi vállalkozás, összeszokott csapattal. Minden munkára ugyanaz az igényesség és írásos garancia jellemző. Néhány elv, amitől a tetőink hosszú évekig megbízhatóan szolgálnak.
            </p>

            <div data-testid="manifesto" style={{ borderTop: "1px solid var(--line)" }}>
              {MANIFESTO.slice(0, 3).map((m, i) => (
                <div
                  key={m.n}
                  data-testid={`manifesto-${i}`}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "48px 1fr",
                    gap: 28,
                    padding: "26px 0",
                    borderBottom: "1px solid var(--line)",
                  }}
                >
                  <span className="font-display" style={{ fontSize: 14, color: "var(--gold)", letterSpacing: "0.04em" }}>
                    {m.n}
                  </span>
                  <div>
                    <h3 className="h3" style={{ margin: 0, marginBottom: 8 }}>
                      {m.title}
                    </h3>
                    <p className="body" style={{ margin: 0, maxWidth: 540 }}>
                      {m.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: 40 }}>
              <span className="eyebrow-muted" style={{ display: "block", marginBottom: 18 }}>
                Igazolt
              </span>
              <ul style={{
                listStyle: "none", padding: 0, margin: 0,
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: "10px 32px",
              }}>
                {CREDENTIALS.slice(0, 5).map((c, i) => (
                  <li
                    key={i}
                    data-testid={`credential-${i}`}
                    style={{
                      display: "flex", alignItems: "flex-start", gap: 10,
                      fontFamily: "Inter, sans-serif", fontSize: 12.5,
                      color: "var(--text-mid)", lineHeight: 1.55,
                    }}
                  >
                    <span aria-hidden style={{
                      width: 5, height: 5, background: "var(--gold)",
                      display: "inline-block", flexShrink: 0, marginTop: 7,
                    }} />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
